import React from "react";

import svg from "../../assets/images/icons/paste.svg";

export const PasteIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Paste"}
    />
);
